<header>
    <h1>
        <img src="https://svelte.dev/svelte-logo-horizontal.svg" alt="Svelte logo" />
    </h1>
</header>

<style>
header {
    background-color: #f7f7f7;
    padding: 20px;
}

h1 {
    margin: 0;
    text-align: center;
}

img {
    width: 180px;
}
</style>
